import React, { Component } from 'react';
import MyButton from '../../components/MyButton/MyButton';
import Strings from 'localization/Strings';
import './Welcome.css';

class Welcome extends Component {
    constructor(props){
        super(props);
        this.onSubmit = props.onSubmit;
        this.onMoreInfo = props.onMoreInfo;
    }
    
    render () {
        return (
            <div className="component-card-content welcome-card">
                <h1 className="display pt15">{Strings.strings.Welcome.WelcomeTitle}</h1>
                <h1 className="display1 pt70">{Strings.strings.Welcome.ToolTitle}</h1>
                <p className="heading2 pt50" dangerouslySetInnerHTML={{__html: Strings.strings.Welcome.DescriptionLine1}}></p>
                <p className="heading2 pt50" dangerouslySetInnerHTML={{ __html: Strings.strings.Welcome.DescriptionLine2 }}></p>
                <div className="pt50">
                    <MyButton type="green" className="start-button" text={Strings.strings.Welcome.StartButton} onClick={() => this.onSubmit()} />
                </div>
                <div className="pt20">
                    <MyButton type="white" className="my-button answer-button start-button" onClick={() => this.onMoreInfo()} text={Strings.strings.Welcome.MoreInfoButton} />
                </div>
            </div> 
        );
    }
}

export default Welcome;